// src/components/blog/BlogHero.jsx

import React, { memo } from 'react';
import blogHeroBg from '../../assets/images/blogs/tech-guy.jpg';

const BlogHero = memo(({ isDark }) => {
  return (
    <section className={`relative py-16 sm:py-20 lg:py-24 overflow-hidden ${
      isDark ? 'bg-black' : 'bg-gray-50'
    }`}>
      <div className="absolute inset-0 z-0">
        <img 
          src={blogHeroBg}
          alt="DOROTS Blog"
          className="w-full h-full object-cover object-center"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/50" />
      </div>

      {isDark && (
        <>
          <div className="absolute top-[-200px] left-[-100px] w-[500px] h-[500px] bg-blue-700/20 rounded-full blur-3xl z-0" />
          
          <div className="absolute bottom-[-250px] right-[-150px] w-[600px] h-[600px] bg-blue-900/20 rounded-full blur-3xl z-0" />
        </>
      )}
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">

          {/* Label */}
          <div className="mb-4">
            <span className={`text-xs sm:text-sm tracking-[0.2em] font-medium px-4 py-2 rounded-full inline-block backdrop-blur-sm ${
              isDark 
                ? 'text-blue-400 bg-blue-700/20 border border-blue-600/30' 
                : 'text-blue-700 bg-white border border-blue-300'
            }`}>
              OUR BLOG
            </span>
          </div>
          
          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight text-white">
            Insights for the{' '}
            <span className="bg-gradient-to-r from-blue-400 via-blue-500 to-blue-700 bg-clip-text text-transparent">
              Digital Era
            </span>
          </h1>
          
          {/* Description */}
          <p className="text-lg sm:text-xl leading-relaxed text-gray-200">
            Expert insights, industry trends, and innovative ideas from the DOROTS team.
            Stay updated with the latest in technology and business transformation.
          </p>

        </div>
      </div>
    </section>
  );
});

BlogHero.displayName = 'BlogHero';

export default BlogHero;